import type { Icon } from '@phosphor-icons/react';
import {
  Airplane,
  Baby,
  Barbell,
  Briefcase,
  Buildings,
  Car,
  CurrencyDollar,
  ForkKnife,
  GraduationCap,
  Hammer,
  Heartbeat,
  House,
  Leaf,
  MagnifyingGlass,
  MapPin,
  PawPrint,
  Scales,
  ShoppingBag,
  Sparkle,
  Stethoscope,
  Storefront,
  Ticket,
  Tooth,
  UsersThree,
  Bank,
  Wrench,
} from '@phosphor-icons/react';
import type { AudienceIcon } from '@shared/audience-icons';

/** Phosphor glyph for each audience size-badge key (src/domain/audience-icons.ts). */
export const AUDIENCE_ICON_COMPONENTS: Record<AudienceIcon, Icon> = {
  car: Car,
  home: House,
  briefcase: Briefcase,
  office: Buildings,
  storefront: Storefront,
  shopping: ShoppingBag,
  dining: ForkKnife,
  health: Heartbeat,
  medical: Stethoscope,
  dental: Tooth,
  fitness: Barbell,
  beauty: Sparkle,
  education: GraduationCap,
  family: Baby,
  pets: PawPrint,
  travel: Airplane,
  entertainment: Ticket,
  finance: Bank,
  money: CurrencyDollar,
  legal: Scales,
  home_services: Wrench,
  construction: Hammer,
  outdoors: Leaf,
  local: MapPin,
  research: MagnifyingGlass,
  people: UsersThree,
};
